import {memo, type ReactElement} from 'react';
import {Button} from './Button';
import {Typography} from './Typography';

interface RadioProps {
  onChange: () => void;
  className?: string;
  label?: string | ReactElement;
  id?: string;
  'data-qa-id': string;
  checked: boolean;
  disabled?: boolean;
  ariaLabel?: string | null;
  disableProcessing?: boolean;
}

export const Radio = memo(
  ({
    onChange,
    className,
    label,
    id,
    'data-qa-id': dataQaId,
    checked,
    disabled,
    ariaLabel = null,
    disableProcessing = false,
  }: RadioProps) => {
    const buttonClassNames = ['radio-wrapper', className].filter(Boolean).join(' ');
    const divClassNames = ['radio', checked && 'checked-radio', disabled && 'disabled']
      .filter(Boolean)
      .join(' ');
    return (
      <Button
        variant="transparent"
        className={buttonClassNames}
        disabled={disabled}
        onClick={onChange}
        id={id}
        data-qa-id={dataQaId}
        data-qa-value={checked.toString()}
        ariaLabel={ariaLabel || undefined}
        disableProcessing={disableProcessing}
      >
        <div className={divClassNames}>{checked && <div className="checked" />}</div>
        <Typography className="radio-label" as="label" htmlFor={id} variant="paragraph2">
          {label}
        </Typography>
      </Button>
    );
  }
);
